import Papa from "papaparse";
import z from "zod";
import { addBannerWithTimeout } from "./centralizedBanner/slice";
import { useAppDispatch } from "./redux/hooks";

export function useCsvImport(
    resetFileState: () => void,
    setName: (name: string) => void,
    setDelimiter: (delimiter: string) => void,
    setFields: (fields: string[]) => void,
    setRows: (rows: Record<string, any>[]) => void,
    setFile: (file: File | null) => void
) {
    const dispatch = useAppDispatch();

    const fileSchema = z.instanceof(File)
        .refine((file) => file.type === "text/csv" || file.name.endsWith('.csv'), {
            message: "Il file deve essere un CSV"
        })
        .refine((file) => file.size > 0, {
            message: "Il file è vuoto"
        })

    const csvHeadersSchema = z.array(z.string().min(1, "Intestazione vuota trovata"))
        .min(1, "Il file CSV deve contenere almeno un'intestazione");

    const handleFileChange = (e: File[]) => {
        const file = e[0];
        if (!file) return;

        const fileValidation = fileSchema.safeParse(file);
        if (!fileValidation.success) {
            const errorMessage = fileValidation.error.issues.map(issue => issue.message).join(', ');
            dispatch(addBannerWithTimeout({
                message: errorMessage,
                variant: "error"
            }));
            resetFileState();
            return;
        }

        setName(file.name);
        Papa.parse(file, {
            complete: (result) => {
                const headersValidation = csvHeadersSchema.safeParse(result.meta.fields ?? []);
                if (!headersValidation.success) {
                    const errorMessage = headersValidation.error.issues.map(issue => issue.message).join(', ');
                    dispatch(addBannerWithTimeout({
                        message: `Errore nelle intestazioni: ${errorMessage}`,
                        variant: "error"
                    }));
                    return;
                }

                setDelimiter(result.meta.delimiter);
                setFields(result.meta.fields ?? []);
                setRows(result.data as Record<string, any>[]);
                setFile(file);
            },
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
        });
    };

    return {
        handleFileChange
    };
}